import Vue from 'vue';
import {
  extend,
  setInteractionMode,
  ValidationProvider,
  ValidationObserver
} from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';
import _ from 'lodash';

extend('required', {
  ...required,
  message: 'This field is required'
});

extend('email', { ...email, message: 'This field must be a valid email' });

// extend('required', required);
extend('min', {
  validate(value, { length }) {
    return value.length >= length;
  },
  params: ['length'],
  message: 'This field must have at least {length} entries.'
});

extend('unique', value => {
  return (
    _.uniq(value).length == value.length ||
    'This field contains duplicate values.'
  );
});
// setInteractionMode('lazy');

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
